const state = {
  viewClientList: [],
  viewSalesList: [],
  viewQuotationList: [],
  viewMasterList: [],
  showContractList: [],

};

const mutations = {
  SET_CLIENT_LIST: (state, payload) => {
    state.viewClientList = payload;
  },
  SET_SALES_LIST: (state, payload) => {
    state.viewSalesList = payload;
  },
  SET_QUOTATION_LIST: (state, payload) => {
    state.viewQuotationList = payload;
  },
  SET_LOCATION_LIST: (state, payload) => {
    state.viewMasterList = payload;
  },
  SET_CONTRACT_LIST: (state, payload) => {
    state.showContractList = payload;
  },




};

const actions = {
  setclientList({
    commit
  }, payload) {
    commit("SET_CLIENT_LIST", payload);
  },
  setSalesList({
    commit
  }, payload) {
    commit("SET_SALES_LIST", payload);
  },
  setquotationList({
    commit
  }, payload) {
    commit("SET_QUOTATION_LIST", payload);
  },
  setLocationList({
    commit
  }, payload) {
    commit("SET_LOCATION_LIST", payload);
  },
  setContractDetail({
    commit
  }, payload) {
    commit("SET_CONTRACT_LIST", payload);
  },


};


const getters = {
  storeClientList: state => state.viewClientList,
  storeSalesList: state => state.viewSalesList,
  storeQuotationsList: state => state.viewQuotationList,
  storeMasterList: state => state.viewMasterList,
  storeContractList: state => state.showContractList,

};

export default {
  state,
  mutations,
  actions,
  getters
};


// WEBPACK FOOTER //
// ./src/store/module/client.js